import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { AlertHelper } from '@bingads-webui-campaign/alert-helper';
import { FilterAgent } from '@bingads-webui/filter-agent';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';

const EXCEED_SAVE_LIMIT = 'ExceededSaveLimit';

export class CampaignAdgroupSelectorFilterAgent extends React.PureComponent {
  static propTypes = {
    onFilterUIChanged: PropTypes.func,
    onFilterStateChanged: PropTypes.func.isRequired,
    upperToolBar: PropTypes.objectOf(PropTypes.any).isRequired,
    filterConfig: PropTypes.objectOf(PropTypes.any).isRequired,
    filterService: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  static defaultProps = {
    onFilterUIChanged: _.noop,
  };

  state = {
    showFilterBar: false,
    showFilterEditor: false,
    showToolBar: true,
    filterBar: null,
    filterEditor: null,
  }

  componentDidMount() {
    this.initializeFilterAgent();
  }

  componentDidUpdate(prevProps) {
    if (this.props.filterConfig !== prevProps.filterConfig ||
      this.props.filterService !== prevProps.filterService ||
      this.props.upperToolBar !== prevProps.upperToolBar) {
      this.initializeFilterAgent();
    }
  }

  onFilterMaxReached = () => {
    this.onFilterOperationFailed({
      message: EXCEED_SAVE_LIMIT,
    });
  }

  onFilterOperationFailed = (errorData = {}) => {
    const { filterConfig: { i18n, maxSavedFilterLimit } } = this.props;
    const alertHelper = new AlertHelper({ i18n });

    if (errorData.message === EXCEED_SAVE_LIMIT) {
      const errMsg = i18n.getString('Error_Campaign_API_FiltersExceedsMaxCount')
        .replace('{0}', maxSavedFilterLimit);
      alertHelper.showAlert(errMsg);
    } else {
      alertHelper.showUnknownError();
    }
  }

  initializeFilterAgent() {
    const { filterConfig, filterService, upperToolBar } = this.props;
    this.filterAgent = new FilterAgent(_.extend({}, filterConfig, {
      filterService,
      toolbarView: {
        view: upperToolBar,
        rendered: true,
      },
    }));
    let filterBar;
    let filterEditor;

    this.filterAgent.on('filter-ui-change', (state) => {
      if (state.showFilterBar) {
        filterBar = this.filterAgent.getFilterBar();
      } else if (this.filterAgent.filterBarAgent.deterministicView) {
        this.filterAgent.filterBarAgent.deterministicView.trigger('removed');
      }

      if (state.showFilterEditor) {
        filterEditor = this.filterAgent.getFilterEditor();
      }

      this.props.onFilterUIChanged(state);
      this.setState({
        filterBar,
        filterEditor,
        showFilterBar: state.showFilterBar,
        showFilterEditor: state.showFilterEditor,
        showToolBar: state.showToolBar,
      });
    });

    this.filterAgent.on('filter-state-changed', this.props.onFilterStateChanged);
    this.filterAgent.on('filter-operation-failed', this.onFilterOperationFailed);
    this.filterAgent.on('filter-max-reached', this.onFilterMaxReached);
  }

  render() {
    return (
      <React.Fragment>
        <div className="upper-toolbar">
          {this.state.showToolBar &&
            <BackboneInstanceWrapper instance={this.props.upperToolBar} managed />}
        </div>

        {this.state.showFilterBar &&
          <BackboneInstanceWrapper className="filterBar" instance={this.state.filterBar} />}
        {this.state.showFilterEditor &&
          <BackboneInstanceWrapper className="filterEditor" instance={this.state.filterEditor} />}
      </React.Fragment>
    );
  }
}
